<template>
    <div class="chat-detail-modal">
        <TitleBaseBox :title="title" :noButton="true" @close="close">
            <div class="chat-content">
                <div class="ask-total-num">
                    <div>
                        <div>会话ID：  {{ data.sessionId }}</div>
                        <div>用户ID：  {{ data.accountId }}</div>
                    </div>
                    <div>
                        {{ $t("zhiji.robotLog.askNums") }}<span>{{ chatTotal }}</span>
                        <div class="trans-box">{{ $t("zhiji.robotLog.chatTranslate") }} <el-switch v-model="isTranslate"> </el-switch></div>
                    </div>
                </div>
                <div class="chat-log-detail scroll-tracker" ref="chatContent">
                    <ChatDetailText 
                        :answer="data.answerDetail"
                        v-for="(item, idx) in chatData" 
                        :key="idx" 
                        :data="item" 
                        :isTranslate="isTranslate"
                        :cur-question="data.userQuestion"
                        :cur-question-createtime="data.createTime"
                    />
                </div>
                <div class="loading-text">{{ computedText }}</div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import { debounce } from "@/views/zhiji/js/common/util.js";

import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import ChatDetailText from "./ChatDetailText";
import * as service from "../service";

export default {
    name: "ChatDetailModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        ChatDetailText
    },
    data() {
        return {
            askTotal: 100,
            chatData: [],
            newchatData: [],
            curPage: 1,
            curPageLen: 10,
            chatTotal: "",
            chatDataLength: "",
            computedText: "",
            isTranslate: false,
            unload: false
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.robotLog.sessionContent");
        },
        loadingText() {
            return this.$t("zhiji.common.dataReading");
        },
        noDataText() {
            return this.$t("zhiji.common.noData");
        }
    },
    watch:{
        isTranslate(n) {
            if (n) {
                this.quesTranslate();
            }
        }
    },
    mounted() {
        let target = this.$refs.chatContent;
        target.addEventListener(
            "scroll",
            debounce(() => {
                // 滚动节流
                this.handleScroll();
            }, 300)
        );
        this.computedText = this.loadingText;
        this.init();
    },
    destroyed() {
        this.unload = true;
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        async init() {
            // 初始化加载 获取内容相同的那条消息记录位置
            await this.getDayChatData()
            const chatList = this.newchatData;
            if (chatList.length > 0) {
                let questionIndex = 0;
                const hasQuestion = chatList.some((item, index) => {
                    // 内容相同 时间搓也相同
                    // * 当时间跨度大 具体的这条聊天记录靠后 会出现请求次数过多问题
                    if (item.userQuestion == this.data.userQuestion && item.addData.createTime === this.data.createTime) {
                        questionIndex = index;
                        return true;
                    }
                    return false;
                });
                if (!hasQuestion) {
                    // 跳出递归条件： 找到了 超过提问时间 组件卸载 
                    if (this.timeOutHandel(chatList[chatList.length - 1].time) || this.unload) return;
                    this.init();
                } else {
                    const index = this.chatData.indexOf(chatList[questionIndex])
                    // 设置高度
                    this.$nextTick(() => {
                        const { offsetTop } = this.$refs.chatContent.children[index];
                        this.$refs.chatContent.scrollTop = offsetTop;
                    });
                }
            }
        },
        close() {
            this.$emit("closeModal");
        },
        async getDayChatData() {
            let reqData = {
                startDate: this.zhiji.dateFormat(new Date(this.data.startDate), "YYYY-MM-DD hh:mm:ss"),
                endDate: this.zhiji.dateFormat(new Date(this.data.endDate), "YYYY-MM-DD hh:mm:ss"),
                curPage: this.curPage,
                size: this.curPageLen,
                channel: "",
                questionType: "",
                answerType: "",
                searchType: "user",
                keyWord: this.data.userId,
                userId: this.data.userId,
                order: "asc" // 升序聊天内容
            };
            let timeDiffer = new Date(reqData.endDate) - new Date(reqData.startDate);

            timeDiffer > 0 &&
                (await this.zhiji.requestByServiceName("queryAskAnswerLog", reqData).then(result => {
                    this.computedText = "";
                    this.curPage = this.curPage + 1;
                    this.chatDataLength = result.tableData.length;
                    this.chatData = this.chatData.concat(result.tableData);
                    this.newchatData = result.tableData;
                    this.chatTotal = result.count;
                    if (this.chatDataLength == 0) {
                        this.computedText = this.noDataText;
                    }
                    if (this.isTranslate) {
                        this.quesTranslate();
                    }
                }));
        },
        handleScroll() {
            if (this.chatDataLength == 10) {
                this.loadingNextPage(this.showLoadingText());
            } else {
                this.computedText = this.noDataText;
                if (!this.showLoadingText()) {
                    this.computedText = "";
                }
            }
        },
        showLoadingText() {
            let clientHeight = this.$refs.chatContent.clientHeight;
            let scrollTop = this.$refs.chatContent.scrollTop;
            let scrollHeight = this.$refs.chatContent.scrollHeight;
            let isScrollBottom = Math.floor(clientHeight + scrollTop) == scrollHeight;

            return isScrollBottom;
        },
        loadingNextPage(isScrollBottom) {
            if (isScrollBottom) {
                this.computedText = this.loadingText;
                this.getDayChatData();
            } else {
                this.computedText = "";
            }
        },
        timeOutHandel(times = "") {
            const outTime = this.data.createTime;
            const curTime = new Date(times.replace(/-/g, "/")) / 1000;
            if (curTime > outTime){
                return true;
            }
            return false;
        },
        async quesTranslate() {
            const translateData = {};
            const textArrary = this.getStrText();
            const bath_query = {
                list: textArrary,
                from: "",
                to: this.$i18n.locale == "cn" ? "zh" : "en",
            };
            if (textArrary.length > 0) {
                const list = await service.batch_translate(bath_query);
                translateData.list = list.list;
                this.chatData = this.chatData.map(item => {
                    const index = translateData.list.findIndex(translateItem => translateItem.id === item.userQuestion);
                    return { ...item, questionTranslate: index !== -1 ? translateData.list[index].output : "" };
                });
            }
        },
        getStrText() {
            let strArrary = [];
            this.chatData
                .filter(function(item) {
                    return !item.questionTranslate;
                })
                .forEach(function(item) {
                    let obj = {};
                    obj.id = item.userQuestion;
                    obj.content = item.userQuestion;
                    strArrary.push(obj);
                });
            return strArrary;
        }
    }
};
</script>

<style lang="less" scoped>
.chat-detail-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .chat-content {
        padding: 4px;
        width: 680px;
        height: 560px;
        position: relative;

        .ask-total-num {
            margin: -14px 0 8px;
            display: flex;
            justify-content: space-between;
        }

        .chat-log-detail {
            position: relative;
            padding: 24px 14px 24px;
            border: 1px solid #d8e4f0;
            background: #fafbfd;
            box-sizing: border-box;
            border-radius: 6px;
            height: 508px;
            overflow-y: auto;
        }
        .loading-text {
            position: absolute;
            bottom: 5px;
            left: -24px;
            padding: 8px;
            text-align: center;
            width: 100%;
            box-sizing: border-box;
        }
    }

    .trans-box {
        width: 200px;
    }
}
</style>
